(function () {
  'use strict';
  var box = document.querySelector('[data-trk-buybox]');
  if (!box || box.dataset.trkDealerInit === '1') return;
  box.dataset.trkDealerInit = '1';

  var endpoint = (box.dataset.endpoint || '').trim();
  var vanTitle = box.dataset.vanTitle || '';
  var vanUrl = box.dataset.vanUrl || location.href;
  var sku = box.dataset.sku || '';

  function modal(name) { return document.querySelector('[data-trk-modal="' + name + '"]'); }
  function openModal(name) {
    var m = modal(name);
    if (!m) return;
    m.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var f = m.querySelector('input, button');
    if (f) setTimeout(function () { try { f.focus(); } catch (e) {} }, 40);
  }
  function closeModals() {
    document.querySelectorAll('[data-trk-modal]').forEach(function (m) { m.hidden = true; });
    document.documentElement.style.overflow = '';
  }

  // ---- Registration toggle (Unregistered ⇄ Registered NSW) ----
  var regToggle = box.querySelector('[data-trk-regtoggle]');
  if (regToggle) {
    var priceValue = box.querySelector('[data-price-value]');
    var priceLabel = box.querySelector('[data-price-label]');
    var regHelp = box.querySelector('[data-reg-help]');
    var regOpts = regToggle.querySelectorAll('[data-reg]');
    regOpts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        regOpts.forEach(function (o) {
          var on = o === opt;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (priceValue && opt.dataset.price) priceValue.textContent = opt.dataset.price;
        if (priceLabel && opt.dataset.label) priceLabel.textContent = opt.dataset.label;
        if (regHelp && opt.dataset.help) regHelp.textContent = opt.dataset.help;
      });
    });
  }

  // ---- Price-breakdown: split the gross (pre-discount) price into base van + factory upgrades + GST ----
  // Uses the factory-upgrades total computed once by the Upgraded Options tab (window.trkFactoryTotal),
  // so the modal and the tab never disagree. Hides the 3 ex-GST rows if that total isn't available.
  function fmtAUD(n) {
    return '$' + Number(n).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function fillBreakdown() {
    var ups = window.trkFactoryTotal;                       // AUD inc GST (from spec-tabs JS)
    var gross = parseFloat(box.dataset.grossAud || '0');    // pre-discount price, inc GST
    var splitRows = document.querySelectorAll('[data-pb-row="split"]');
    if (!ups || ups <= 0 || !gross) {
      splitRows.forEach(function (r) { r.style.display = 'none'; });
      return;
    }
    var upsEx = ups / 1.1;
    var baseEx = gross / 1.1 - upsEx;
    var gst = gross - gross / 1.1;
    var set = function (sel, val) { var el = document.querySelector(sel); if (el) el.textContent = val; };
    set('[data-pb-base]', fmtAUD(baseEx));
    set('[data-pb-ups]', '+ ' + fmtAUD(upsEx));
    set('[data-pb-gst]', '+ ' + fmtAUD(gst));
    splitRows.forEach(function (r) { r.style.display = ''; });
  }
  fillBreakdown();
  document.addEventListener('trk:factory-total', fillBreakdown);

  // ---- Open triggers ----
  document.querySelectorAll('[data-trk-pricemodal]').forEach(function (b) {
    b.addEventListener('click', function () { fillBreakdown(); openModal('price'); });
  });
  document.querySelectorAll('[data-trk-enq]').forEach(function (b) {
    b.addEventListener('click', function () {
      var subj = b.dataset.trkEnqSubject || 'Enquire about this van';
      var t = document.querySelector('[data-trk-enq-title]');
      if (t) t.textContent = subj;
      box._trkEnqSubject = subj;
      openModal('enq');
    });
  });

  // ---- Generic modal opener (e.g. "Deposit terms →") ----
  document.querySelectorAll('[data-trk-modal-open]').forEach(function (b) {
    b.addEventListener('click', function () { openModal(b.dataset.trkModalOpen); });
  });

  // ---- "Hold this van — $1,000 deposit" → secure checkout ----
  // Clears the cart, adds the single $1,000 holding-deposit line carrying this van's identity
  // as line-item properties (so the paid order tells the Worker which van to mark on hold),
  // then sends the buyer straight to checkout.
  document.querySelectorAll('[data-trk-deposit]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var variant = b.dataset.depositVariant;
      if (!variant) return;
      var orig = b.textContent;
      b.disabled = true; b.textContent = 'Redirecting to checkout…';
      var props = {
        'Holding deposit for': b.dataset.vanTitle || (box && box.dataset.vanTitle) || 'Van',
        'Van product ID': b.dataset.vanProductId || '',
        'Van URL': b.dataset.vanUrl || ''
      };
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1, properties: props }] })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/checkout'; })
        .catch(function () { b.disabled = false; b.textContent = orig; alert('Sorry — we couldn\'t start the deposit checkout. Please try again or use “Enquire about this van”.'); });
    });
  });

  // ---- Close triggers ----
  document.querySelectorAll('[data-trk-eclose]').forEach(function (b) {
    b.addEventListener('click', closeModals);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModals();
  });

  // ---- Enquire submit → Worker lead ----
  var form = document.querySelector('[data-trk-enq-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var hp = form.querySelector('[name="website"]');
      if (hp && hp.value) return; // honeypot tripped
      var err = document.querySelector('[data-trk-enq-err]');
      if (err) { err.hidden = true; err.textContent = ''; }
      var get = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? (el.value || '').trim() : ''; };
      var first = get('first'), last = get('last');
      var name = (first + ' ' + last).trim();
      var lead = { name: name, email: get('email'), phone: get('phone') };
      var subject = box._trkEnqSubject || 'Enquire about this van';
      var note = subject + '\n\nVan: ' + vanTitle + (sku ? ' (Stock #' + sku + ')' : '') + '\nPage: ' + vanUrl +
                 (get('message') ? '\n\nMessage: ' + get('message') : '');

      var btn = form.querySelector('[type="submit"]');
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

      function done() {
        form.hidden = true;
        var d = document.querySelector('[data-trk-enq-done]');
        if (d) d.hidden = false;
      }
      function fail() {
        if (btn) { btn.disabled = false; btn.textContent = orig; }
        if (err) { err.hidden = false; err.textContent = 'Couldn’t send just now — please call us or email info@trekano.com and we’ll sort it.'; }
      }

      if (!endpoint) { done(); return; } // no Worker configured → optimistic (form still captured client-side)

      try {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            type: 'lead',
            customer: lead,
            van: vanTitle,
            note: note,
            website: hp ? hp.value : '',
            tags: ['Van enquiry', subject]
          })
        }).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; });
        }).then(function (res) {
          if (res.ok && res.d && res.d.ok) { done(); } else { fail(); }
        }).catch(fail);
      } catch (e) { fail(); }
    });
  }
})();
